import { render, staticRenderFns } from "./InfoReportGroup.vue?vue&type=template&id=10fa50fc&scoped=true&"
import script from "./InfoReportGroup.vue?vue&type=script&lang=js&"
export * from "./InfoReportGroup.vue?vue&type=script&lang=js&"
import style0 from "./InfoReportGroup.vue?vue&type=style&index=0&id=10fa50fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa50fc",
  null
  
)

export default component.exports